import "./IconCaret.scss";

type Props = {
  direction?: "up" | "down";
  size?: "xs" | "sm" | "md" | "lg";
  color?: string;
};

export const IconCaret = ({ direction = "up", size = "md", color }: Props) => {
  const sizeClass = `IconCaret--${size}`;
  const directionClass = `IconCaret--${direction}`;
  const viewBox = size === "xs" ? "0 128 320 193" : "0 0 320 512";

  return (
    <div className={`IconCaret ${sizeClass} ${directionClass}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={viewBox}
        fill={color || "currentColor"}
        className="IconCaret__svg"
      >
        <path d="M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z" />
      </svg>
    </div>
  );
};
